import { render } from "./DocumentReportFieldSelectionQuality.vue?vue&type=template&id=51d262fc&scoped=true&ts=true"
import script from "./DocumentReportFieldSelectionQuality.vue?vue&type=script&lang=ts"
export * from "./DocumentReportFieldSelectionQuality.vue?vue&type=script&lang=ts"

import "./DocumentReportFieldSelectionQuality.vue?vue&type=style&index=0&id=51d262fc&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d262fc"]])

export default __exports__